<template>
  <section class="layout-vertical" :class="{ 'is-loading': isLoading }" :style="styles">
    <div class="title">
      <slot name="title" />
    </div>
    <div v-if="$slots.switcher" class="switcher">
      <slot name="switcher"></slot>
    </div>
    <div class="prices">
      <slot name="prices" />
    </div>
  </section>
</template>
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    primaryColor: {
      type: String,
      required: true
    },
    secondaryColor: {
      type: String,
      required: true
    },
    terciaryColor: {
      type: String,
      required: true
    },
    quaternaryColor: {
      type: String,
      required: true
    },
    quinaryColor: {
      type: String,
      required: true
    },
    senaryColor: {
      type: String,
      required: true
    },
    septenaryColor: {
      type: String,
      required: true
    },
    octonaryColor: {
      type: String,
      required: true
    },
    nonaryColor: {
      type: String,
      required: true
    },
    decenaryColor: {
      type: String,
      required: true
    },
    undenaryColor: {
      type: String,
      required: true
    },
    backgroundImageUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    styles() {
      return `
        --primary-color: ${this.primaryColor};
        --secondary-color: ${this.secondaryColor};
        --terciary-color: ${this.terciaryColor};
        --quaternary-color: ${this.quaternaryColor};
        --quinary-color: ${this.quinaryColor};
        --senary-color: ${this.senaryColor};
        --septenary-color: ${this.septenaryColor};
        --octonary-color: ${this.octonaryColor};
        --nonary-color: ${this.nonaryColor}; /* currently unused */
        --decenary-color: ${this.decenaryColor};
        --undenary-color: ${this.undenaryColor};

        --bg-image-url: url(${this.backgroundImageUrl});

        --template-areas: 'title' ${
          this.$slots.switcher ? "'switcher'" : "'prices'"
        } 'prices' 'prices';
      `;
    }
  }
};
</script>

<style lang="scss" scoped>
.layout-vertical {
  --border-radius: 20px;

  display: grid;
  justify-items: center;
  gap: 4em;
  grid-template-rows: auto auto auto auto;
  grid-template-areas: var(--template-areas);

  margin-inline: -15px;

  background-image: var(--bg-image-url);
  background-repeat: no-repeat;
  background-size: cover;

  .title {
    grid-area: title;
    display: flex;
    width: 100%;
    justify-items: center;
    justify-content: center;
    padding-right: 20px;
    padding-left: 20px;
  }
  .switcher {
    grid-area: switcher;
  }

  .prices {
    grid-area: prices;
    padding-bottom: 3em;

    > ul {
      list-style: none;
      display: grid;
      gap: 1.5em;
      padding: 0;
      grid-template-columns: repeat(1, minmax(20em, 24em));
      @include min-lg {
        gap: 1em;
        grid-template-columns: repeat(3, minmax(20em, 24em));
      }
      ::v-deep {
        li {
          display: grid;
        }
        > li.middle {
          --bg-color: var(--quaternary-color);
          & > * {
            grid-area: 1/1/2/2;
          }
          .highlight-text {
            align-self: start;
            width: fit-content;
            justify-self: center;
            transform: translateY(-50%);

            display: flex;
            gap: 0.3em;
            color: var(--primary-color);
            fill: var(--primary-color);
            border: 1px solid var(--primary-color);
            border-radius: 2.8em;
            padding: 0.2em 1em;
            background-color: white;
          }
        }
      }
    }
  }

  &.is-loading ul {
    grid-auto-rows: 40rem;
  }
}
</style>
